import { AssetsService } from "app/services/AssetsService";
import { StyledBanner } from "app/pages/digital-suite/home-page/components/FeedbackBanner/FeedbackBanner.styled";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

export const FeedbackBanner = () => {
    const i18n = i18nFilter();

    const onClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Homepage/provide feedback");
    };

    return (
        <div data-automation={"platform-homepage-feedback-banner"}>
            <StyledBanner
                title={i18n("growth.homepage.feedbackBanner.title")}
                subtitle={i18n("growth.homepage.feedbackBanner.subtitle")}
                buttonType="outlined"
                buttonIconName="response"
                buttonText={i18n("growth.homepage.feedbackBanner.button")}
                onButtonClick={onClick}
                iconImagePath={AssetsService.assetUrl("/images/homepage/feedback-banner-illustration.svg")}
                iconImageHeight={56}
                iconImageWidth={56}
            />
        </div>
    );
};
